const actions = {
    FETCH_IMPORT_CAMERA_LOGS: "FETCH_IMPORT_CAMERA_LOGS",
    LOAD_SITE_LIST: "LOAD_SITE_LIST"
  };
  
  export default actions;